import { Component, computed, inject } from '@angular/core';
import { MobileFrameService, MobilePagePart } from '@eforall/mobile';


@Component({
	selector: 'calendar-page',
	imports: [
		MobilePagePart,
	],
	templateUrl: './calendar.page.html'
})

export class CalendarPage {
	private frame = inject(MobileFrameService);

	constructor() {
		this.frame.setUrlMetadata({
			url: '/calendar',
			backUrl: '/',
			pageName: computed(() => `Calendar`),
			headerText: computed(() => `Calendar`),
		});
	}

}